import React, { createContext, useState } from "react";
export const AuthContext = createContext();

const safeLocal = {
  get(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn("localStorage.get failed", e);
      return null;
    }
  },
  set(key, val) {
    try {
      localStorage.setItem(key, val);
    } catch (e) {
      console.warn("localStorage.set failed", e);
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn("localStorage.remove failed", e);
    }
  },
};

const readStoredUser = () => {
  const storedUser = safeLocal.get("user");
  if (storedUser && storedUser !== "undefined") {
    try {
      return JSON.parse(storedUser);
    } catch (e) {
      console.warn("Failed parsing stored user", e);
      return null;
    }
  }
  return null;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(readStoredUser());

  const loginUser = (userData) => {
    try {
      safeLocal.set("user", JSON.stringify(userData));
    } catch (e) {
      console.warn("Failed to store user", e);
    }
    setUser(userData);
  };

  const logoutUser = () => {
    safeLocal.remove("user");
    safeLocal.remove("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};
